export default __webpack_public_path__ + "static/media/gl_6.1b151e85.png";